import styled, { css } from 'styled-components';
import { sidenavTokens } from '../../tokens';

type StyledSideNavIconBadgeProps = {
  isBadged?: boolean;
};

export const StyledSideNavIconBadge = styled.span<StyledSideNavIconBadgeProps>`
  background-color: ${sidenavTokens.IconBadgeBackgroundColorBaseDefault};
  border-radius: ${sidenavTokens.IconBadgeBorderRadiusBaseDefault};
  height: ${sidenavTokens.IconBadgeDimensionBaseDefault};
  position: absolute;
  right: ${sidenavTokens.IconBadgePositionRightBaseDefault};
  top: ${sidenavTokens.IconBadgePositionTopBaseDefault};
  width: ${sidenavTokens.IconBadgeDimensionBaseDefault};
  transform: ${({ isBadged }) => (isBadged ? 'scale(1)' : 'scale(0)')};
  transition: ${`transform ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault}`};
  transition-delay: 0s;
`;

type StyledSideNavIconProps = {
  isActive?: boolean;
};

export const StyledSideNavIcon = styled.span<StyledSideNavIconProps>`
  border-radius: ${sidenavTokens.IconBorderRadiusBaseDefault};
  position: relative;
  transition: ${`width ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault},
          margin-right ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault},
          `};
  text-align: center;
  display: inline-flex;
  margin-right: ${sidenavTokens.IconMarginRightBaseOpen};
  padding: 2px;

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${sidenavTokens.IconBackgroundColorActiveDefault};
    `}
`;
